import { useMediaQuery, useTheme } from '@mui/material';

/**
 * True below the `sm` breakpoint: a phone held upright.
 *
 * For layout that has to change shape rather than just reflow, such as a
 * month grid that is unreadable at 390px or a header action that has no room
 * beside the page title. `noSsr` evaluates on mount, so the first render
 * already picks the phone layout instead of flashing the desktop one.
 */
export function useIsPhone(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
}
